/* ════════════════════════════════════════════════════════════════════
   lefelin — Comportements partagés des sections d'accueil modulaires
   (révélation au scroll .lfh-rv, carrousels [data-prow], quiz [data-quiz]).
   Idempotent : init une seule fois, re-scanne sur shopify:section:load.
   ════════════════════════════════════════════════════════════════════ */
(function () {
  if (window.__lfHomeInit) return;
  window.__lfHomeInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;
  function getIO() {
    if (io || reduce || !('IntersectionObserver' in window)) return io;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    return io;
  }

  function initReveal(root) {
    var items = root.querySelectorAll('.lfh-rv');
    var obs = getIO();
    items.forEach(function (el) {
      if (el.dataset.lfhRv) return;
      el.dataset.lfhRv = '1';
      if (el.classList.contains('lfh-stagger')) {
        var kids = el.children;
        for (var i = 0; i < kids.length; i++) { kids[i].style.transitionDelay = (i * 70) + 'ms'; }
      }
      if (obs) { obs.observe(el); } else { el.classList.add('is-in'); }
    });
  }

  function initProw(root) {
    root.querySelectorAll('[data-prow]').forEach(function (prow) {
      if (prow.dataset.lfhProw) return;
      prow.dataset.lfhProw = '1';
      var track = prow.querySelector('[data-prow-track]');
      var prev = prow.querySelector('[data-prow-prev]');
      var next = prow.querySelector('[data-prow-next]');
      if (!track || !prev || !next) return;
      function step() {
        var card = track.querySelector('.lfh-pcard, .lfh-post');
        var w = card ? card.getBoundingClientRect().width : 220;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 16) || 16;
        return Math.max(1, Math.round(track.clientWidth / (w + gap))) * (w + gap);
      }
      function sync() {
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
      }
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(sync); }, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  function initQuiz(root) {
    root.querySelectorAll('[data-quiz]').forEach(function (quiz) {
      if (quiz.dataset.lfhQuiz) return;
      quiz.dataset.lfhQuiz = '1';
      var recos = {};
      try { recos = JSON.parse(quiz.querySelector('[data-quiz-recos]').textContent); } catch (e) {}
      var steps = [].slice.call(quiz.querySelectorAll('.lfh-quiz-step'));
      var qSteps = steps.filter(function (s) { return s.getAttribute('data-step') !== 'result'; });
      var resultStep = quiz.querySelector('[data-step="result"]');
      var bar = quiz.querySelector('.lfh-quiz-bar > i');
      var backBtn = quiz.querySelector('[data-quiz-back]');
      var restart = quiz.querySelector('[data-quiz-restart]');
      var total = qSteps.length;
      var idx = 0, votes = [];

      function computeReco() {
        var tally = {}, best = null, bestN = 0;
        votes.forEach(function (t) { if (t) { tally[t] = (tally[t] || 0) + 1; } });
        votes.forEach(function (t) { if (t && tally[t] > bestN) { best = t; bestN = tally[t]; } });
        if (!best) best = quiz.getAttribute('data-quiz-default') || '';
        var reco = recos[best] || recos[quiz.getAttribute('data-quiz-default')] || {};
        var titleEl = resultStep.querySelector('[data-reco-title]');
        var linkEl = resultStep.querySelector('[data-reco-link]');
        if (titleEl && reco.t) { titleEl.textContent = reco.t; }
        if (linkEl && reco.u) { linkEl.setAttribute('href', reco.u); }
      }
      function render() {
        steps.forEach(function (s) { s.classList.remove('is-active'); });
        if (idx >= total) { resultStep.classList.add('is-active'); computeReco(); }
        else { qSteps[idx].classList.add('is-active'); }
        if (bar) bar.style.width = Math.round((Math.min(idx, total) / total) * 100) + '%';
        if (backBtn) backBtn.hidden = (idx === 0);
      }
      quiz.querySelectorAll('.lfh-quiz-opt').forEach(function (opt) {
        opt.addEventListener('click', function () {
          opt.parentNode.querySelectorAll('.lfh-quiz-opt').forEach(function (s) { s.classList.remove('is-on'); });
          opt.classList.add('is-on');
          votes[idx] = opt.getAttribute('data-target') || '';
          window.setTimeout(function () { idx++; render(); }, 190);
        });
      });
      if (backBtn) backBtn.addEventListener('click', function () { if (idx > 0) { idx--; votes.length = idx; render(); } });
      if (restart) restart.addEventListener('click', function () {
        idx = 0; votes = [];
        quiz.querySelectorAll('.lfh-quiz-opt.is-on').forEach(function (o) { o.classList.remove('is-on'); });
        render();
      });
      render();
    });
  }

  function initAll(root) {
    root = root || document;
    initReveal(root);
    initProw(root);
    initQuiz(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
